export class SyncItemBlockPartRequest {
  itemId: number;
  quantity: number;
  constructor(itemId: number, quantity: number) {
    this.itemId = itemId;
    this.quantity = quantity;
  }
}

export default class UpsertItemBlockRequest {
  siteId: number;
  code: string;
  name: string;
  partItems: SyncItemBlockPartRequest[];
  constructor(
    siteId: number,
    code: string,
    name: string,
    partItems: SyncItemBlockPartRequest[]
  ) {
    this.siteId = siteId;
    this.code = code;
    this.name = name;
    this.partItems = partItems;
  }
}
